/**
 * „Mi ez?" — az ügyfél válaszának elküldése.
 *
 * KÜLÖN FÁJL, hogy a komponens tesztje ki tudja cserélni (ugyanaz a fogás,
 * mint az `openUploadedFile`-nál). A `PATCH` és nem `PUT`: a bizonylatnak egy
 * mezőjét állítjuk, nem az egészet írjuk felül.
 */

import { api } from '@/lib/api-client';
import type { ClientDocType } from './types';

export async function declareDocType(
  documentId: string,
  docType: ClientDocType,
  /** A feltöltés utáni írásnál (#85) a „Mégsem" és az időkorlát fogantyúja. */
  signal?: AbortSignal
): Promise<void> {
  await api(`/documents/${encodeURIComponent(documentId)}/type`, {
    method: 'PATCH',
    body: JSON.stringify({ docType }),
    signal,
  });
}
